import Vue from 'vue';
import Modal from 'components/modules/accordions-modals/modals/modal/modal.mixin';
import ViewportHelper from 'utils/ViewportHelper';

Vue.component('modal-form-vue', {
  mixins: [Modal],
  props: {
    'cookie': String
  },

  data: function() {
    return {
      'currentStep': 1,
      'triggerSource': 'popup'
    }
  },

  mounted() {
    this.handleSignUpCookie();
  },

  methods: {
    handleTriggerClick(event) {
      this.isExpanded = !this.isExpanded;

      // Tracks where the modal was opened from (for form analytics).
      if (event.currentTarget.closest('.header')) {
        this.triggerSource = 'header';
      }
      else if (event.currentTarget.closest('.footer')) {
        this.triggerSource = 'footer';
      }
    },

    /**
     * Responds to a successful form submission.
     *
     * @param {Boolean} reset - Whether or not the modal form should reset.
     */
    handleStepSuccess(reset) {
      if (reset) {
        this.isExpanded = false;

        // Waits until after the modal finishes fading out to reset the step.
        setTimeout(() => {
          this.currentStep = 1;
        }, 1000);
      }
      else {
        this.currentStep++;
        this.$refs.close.focus();
      }
    },

    /**
     * [saveToLocalStorage saves a cookie in local storage to ensure user only sees the newsletter sign-up once]
     * @return {void}
     */
    saveToLocalStorage() {
      localStorage.setItem(this.cookie, 'viewed');
    },

    /**
     * [handleSignUpCookie handles displaying the signup modal and saving a cookie to localstorage]
     * @return {void}
     */
    handleSignUpCookie() {
      if (!ViewportHelper.isMobile() && this.cookie && localStorage.getItem(this.cookie) === null) {
        this.isExpanded = true;
        this.saveToLocalStorage()
      }
    }
  }
});
